import styled from "@emotion/styled";
export const StyledAshbyInternalEmployeeLink = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-right: 4px;

  .employee-link {
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    font-size: 0.8125rem;
    color: #323338;
    cursor: pointer;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid #0073ea;
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  .employee-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(50, 51, 56, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
    animation: ashby-internal-fade-in 0.18s ease-out;
  }

  .employee-modal {
    position: relative;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22);
    padding: 40px 48px 44px;
    max-width: 520px;
    width: 100%;
    text-align: center;
    animation: ashby-internal-pop-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .employee-modal-close {
    position: absolute;
    top: 14px;
    right: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    border: none;
    border-radius: 50%;
    color: #676879;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      color: #323338;
      background: #f1f3f6;
    }

    &:focus-visible {
      outline: 2px solid #0073ea;
      outline-offset: 2px;
    }
  }

  .employee-modal-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f2a52;
    line-height: 1.25;
    margin: 0 0 18px;
    white-space: nowrap;
  }

  .employee-modal-body {
    font-size: 1rem;
    color: #4a4e5e;
    line-height: 1.55;
    margin: 0;
  }

  .employee-modal-cta {
    color: #0073ea;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @keyframes ashby-internal-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @keyframes ashby-internal-pop-in {
    from { opacity: 0; transform: translateY(8px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  @media (max-width: 520px) {
    .employee-modal {
      padding: 40px 24px 28px;
    }

    .employee-modal-title {
      font-size: 1.25rem;
      white-space: normal;
    }
  }
`;
